import React, {Component} from 'react'
import Markdown from 'markdown-to-jsx'
import FirstPage from './FirstPage.json'
import Reader from '../../controller/Reader'
import Alert from '../etc/Alert'

const Desc = FirstPage.desc

export default class DocsPost extends Component {

	state = { 
        idName : '',
        title : 'DEV CHEAT SHEET',
        desc : Desc,
        isAlert : false
    }


    componentWillReceiveProps(nextProps) {

        if(nextProps.catg === '') {
            return
        }

        const condition = {
            url : '/api/docs/detail/' + nextProps.catg
        }

        Reader(condition, res => {

            if(res.data !== null) {

                this.setState({
                    idName : res.data._id,
                    title : res.data.title,
                    desc : res.data.description
                })

            }
        })        
    }


    editFx = (e) => {

        if(!this.props.isLogin) {
            this.setState({ isAlert : true })
            return
        }

        if(e.target.id === 'newPost') {

            this.props.isEdit('new')    
        
        } else {
        
            this.props.isEdit(this.state.idName)
        
        }

    }


    closeFx = () => {
        this.setState(
            { isAlert : false }
        )
    }
    

    render() {

        return (

            <React.Fragment>

            { this.state.isAlert ? <Alert alert='Access Denied' closeMe = { this.closeFx } /> : null }

                <div id = 'DocsTop'>

                    <span id='editPost' onClick={this.editFx}>Edit</span>
                    <i className='material-icons'>add</i>
                
                    <span id='newPost' onClick={this.editFx}>New Post</span>
                    <i className='material-icons'>add</i>

                </div>
 
                <div className = 'DocsPostBox'>

                                        
                    <h1 id = 'DocsPostTitle'>

                    { this.state.title }</h1>

                    <Markdown className='markdown'>

                    { this.state.desc }

                    </Markdown>

                </div>
                
            </React.Fragment>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/docs/DocsPost.js